import React from 'react';
import {
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  ControlLabel,
  FormControl
} from 'react-bootstrap';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { CSSTransitionGroup } from 'react-transition-group';
import { formatDate, validateRequired } from '../../helpers';
import Input from '../../components/Input';

class InsightSetDetailsForm extends React.Component {
  render() {
    const insightSetTypes = this.props.currentInsightSet.settings
      .insightSetType;
    return (
      <div>
        <Form onSubmit={this.props.handleSubmit}>
          <Row />
          <Row>
            <Col sm={12} className="form-input">
              <Field
                component={Input}
                type="text"
                placeholder="Insight Set name"
                label="Insight Set name"
                name="name"
                validate={validateRequired}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} className="form-input">
              <Field
                component={Input}
                type="text"
                placeholder="Insight Set information"
                label="Insight Set information"
                name="information"
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} className="form-input">
              <Field
                component={Input}
                type="toggle"
                name="isArchived"
                label="Active"
                reverse
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} className="form-input">
              <FormGroup>
                <Field
                  component={Input}
                  type="radioGroup"
                  name="insightSetTypeId"
                  label="Type"
                  normalize={value => parseInt(value, 10)}
                  options={insightSetTypes}
                  validate={validateRequired}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={12} className="form-input">
              <Field
                component={Input}
                type="toggle"
                name="shareWithAllIndustries"
                label="Shared with all industries"
              />
            </Col>
          </Row>
          {this.props.params.insightSetId !== 'new' && (
            <div>
              <Row>
                <Col sm={12} className="form-input">
                  <ControlLabel>Date created</ControlLabel>
                  <FormControl.Static>
                    {formatDate(this.props.dateCreated)}
                  </FormControl.Static>
                </Col>
              </Row>
              <Row>
                <Col sm={12} className="form-input">
                  <ControlLabel>Last changed</ControlLabel>
                  <FormControl.Static>
                    {formatDate(this.props.dateUpdated)}
                  </FormControl.Static>
                </Col>
              </Row>
              <Row>
                <Col sm={12} className="form-input">
                  <ControlLabel>Last changed by</ControlLabel>
                  <FormControl.Static>
                    {this.props.lastChangedBy}
                  </FormControl.Static>
                </Col>
              </Row>
            </div>
          )}
          <Row>
            <Col sm={12} className="form-input">
              <Button
                bsStyle="primary"
                type="submit"
                disabled={this.props.isSaving}
              >
                {this.props.isSaving ? 'Saving...' : 'Save'}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <CSSTransitionGroup
                transitionName="fade"
                transitionEnterTimeout={300}
                transitionLeaveTimeout={300}
              >
                {this.props.successMsg && (
                  <p className="text-success">{this.props.successMsg}</p>
                )}
              </CSSTransitionGroup>
            </Col>
          </Row>
        </Form>
        {this.props.errorMsg && (
          <div className="alert alert-danger">{this.props.errorMsg}</div>
        )}
      </div>
    );
  }
}

// Decorate the form component
InsightSetDetailsForm = reduxForm({
  form: 'insightSetDetailsForm' // a unique name for this form
})(InsightSetDetailsForm);

const selector = formValueSelector('insightSetDetailsForm');

const mapStateToProps = state => {
  return {
    dateCreated: selector(state, 'dateCreated'),
    dateUpdated: selector(state, 'dateUpdated'),
    lastChangedBy: selector(state, 'lastChangedBy')
  };
};

export default connect(mapStateToProps)(InsightSetDetailsForm);



// WEBPACK FOOTER //
// ./src/containers/insightset/InsightSetDetailsForm.js